import { render, staticRenderFns } from "./_InstanceGroupForm.vue?vue&type=template&id=11bd6fc7&"
import script from "./_InstanceGroupForm.vue?vue&type=script&lang=ts&"
export * from "./_InstanceGroupForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports